import * as React from 'react';
import {Checkbox, FormControlLabel} from '@mui/material';
import {withFormikField} from 'src/utils/formik';

interface ZsCheckboxProps {
    label: string;
    tooltip: string;
    dateFormat?: string;
    onChange: ({target: {value}}: any) => void;
    value: boolean;
}

export const ZsCheckbox: React.FC<ZsCheckboxProps> = ({
                                                                  label,
                                                                  tooltip,
                                                                  value,
                                                                  onChange,
                                                                  ...props
                                                              }) => {
    const toggleChecked = React.useCallback(
        (e, checked) => {
            onChange({...e, target: {value: checked}});
        },
        [onChange]
    );
    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox className="checkbox" style={{
                      color: '#54c0b5',
                    }} checked={value} onChange={toggleChecked} {...props} />
                }
                label={label}
            />
        </>
    );
};

const ZsFormikCheckbox = withFormikField(ZsCheckbox);

export default ZsFormikCheckbox;
